import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, Injector } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Params } from '@angular/router';
import { Location } from '@angular/common';

import { UiComponent } from '../ui/ui.component';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { ValidatorService } from '../../services/validator/validator.service';
import { ReactiveformService } from '../../services/reactiveform/reactiveform.service';
import { DataService } from '../../services/data/data.service';

declare const toastr: any;

@Component({
  selector: 'reactiveform',
  template: '',
  styles: [`
  .card {
      margin-top: 50px;
  }
  .navbar-btn {
      margin-top: 0px;
      margin-bottom: 0px;
      padding: .6rem 1rem;
  }
  .btn-backlink {
      left: -15px;
  }`]
})

export class ReactiveformComponent extends UiComponent {
  public subscription: any;
  @Input() public title: string;
  @Input() public caption: any = '';
  @Input() public glyph: string;
  @Input() public restName: string;
  @Input() public backLink: string;
  public _id: number = 0;
  @Input() public modal: boolean = false;
  @Input() public closeModalAfterSave: boolean = true;
  @Input() public locked: boolean = false;
  public error: any = null;
  public item: any = {};
  public validators: any;
  @Input() public form: FormGroup;
  public active: boolean = false;
  public loading: boolean = false;
  public formErrors: any = {};
  public displayToolbar: boolean = true;
  public validationMessages: any;
  public initValue: any = [];
  close: Function;
  @Output() updated: EventEmitter<any> = new EventEmitter<any>();
  @Output() created: EventEmitter<any> = new EventEmitter<any>();

  protected fb: FormBuilder;
  protected validatorService: ValidatorService;
  protected reactiveformService: ReactiveformService;
  protected genericdatasetService: GenericdatasetService;
  //protected hotkeysService: HotkeysService;
  protected location: Location;
  protected dataService: DataService;

  constructor(injector: Injector) {
    super(injector);
    this.fb = injector.get(FormBuilder);
    this.validatorService = injector.get(ValidatorService);
    this.reactiveformService = injector.get(ReactiveformService);
    this.genericdatasetService = injector.get(GenericdatasetService);
    //this.hotkeysService = injector.get(HotkeysService);
    this.location = injector.get(Location);
    this.dataService = injector.get(DataService);
    /*this.hotkeysService.add(new Hotkey('f2', (event: KeyboardEvent): boolean => {
      this.onReset();
      return false;
    }, (['INPUT', 'SELECT', 'TEXTAREA'])));
    this.hotkeysService.add(new Hotkey('f3', (event: KeyboardEvent): boolean => {
      this.onCreate();
      return false;
    }, (['INPUT', 'SELECT', 'TEXTAREA'])));
    this.hotkeysService.add(new Hotkey('f4', (event: KeyboardEvent): boolean => {
      this.onSubmit(this.form);
      return false;
    }, (['INPUT', 'SELECT', 'TEXTAREA'])));
    this.hotkeysService.add(new Hotkey('f5', (event: KeyboardEvent): boolean => {
      //COPY
      return false;
    }, (['INPUT', 'SELECT', 'TEXTAREA'])));
    this.hotkeysService.add(new Hotkey('f6', (event: KeyboardEvent): boolean => {
      this.onDelete();
      return false;
    }, (['INPUT', 'SELECT', 'TEXTAREA'])));
    this.hotkeysService.add(new Hotkey('escape', (event: KeyboardEvent): boolean => {
      if (this.modal) {
        this.onClose();
      } else {
        this.goBack();
      }
      return false;
    }));*/
  }

  initializeValue(initValue: any, destValue: any) {
    if (initValue != null) {
      for (let i = 0; i <= initValue.length - 1; i++) {
        destValue[this.initValue[i].parentFieldName] = initValue[i].parentId;
      }
    }
  }

  load() {
    let id: number = this.id;
    if (id == 0) id = 111;
    this.loading = true;
    this.genericdatasetService.setrestName(this.restName);
    this.genericdatasetService.setmodelName(this.backLink.charAt(0).toUpperCase() + this.backLink.slice(1));
    this.genericdatasetService
      .getItem(id)
      .subscribe(
      (item) => {
        this.initializeValue(this.initValue, item);
        this.loadData(item);
        this.validatorFromObject();
        this.buildForm();
      },
      (error) => {
        this.loading = false;
        this.error = error;
      },
      () => {
        this.loading = false;
      });
  }

  loadData(item: any) {
    this.item = item;
    if (this.id > 111) {
      this.setCaption();
    } else {
      this.caption = 'Nouveau';
    }
    if (item.locked != null) {
      this.locked = item.locked;
    } else {
      this.locked = false;
    }
    //if (this.form) this.form.reset();
    //this.validatorFromObject();
    //this.buildForm();
  }

  setCaption(caption?: string) {
    if (caption) {
      this.caption = caption;
    } else {
      this.caption = '';
    }
  }

  @Input() public set id(id: number) {
    this._id = id;
    this.active = false;
    //this.form = null;
    this.load();
    //this.AfterOnInit();
  }

  public get id() {
    return this._id;
  }

  AfterOnInit() {
    /*if (this.restName) {
      this.genericdatasetService.setrestName(this.restName);
      if (this.modal) {
        this.load();
      } else if (this.id >= 0) {
        this.load();
      } else {
        this.subscription = this.route.params
          .subscribe((params) => {
            if (this.dataService.getStorage()) {
              this.initValue = this.dataService.getStorage().initValue;
            }
            if (params['id'] != undefined) {
              this.id = +params['id'];
              //this.load();
            }
          });
      }
    }*/
  }

  ngOnInit() {
    if (this.restName) {
      this.genericdatasetService.setrestName(this.restName);
      if (this.route) {
        this.subscription = this.route.params
          .subscribe((params) => {
            if (this.dataService.getStorage()) {
              this.initValue = this.dataService.getStorage().initValue;
            }
            if (params['id'] != undefined) {
              this.id = +params['id'];
              //this.load();
            }
          });
      }
    }
    //if (!this.id) this.id = this._id;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onDelete() {
    // TO DO ADD CONFIRMATION MODAL DANGER MODE
    this.active = false;
    this.loading = true;
    let caption = 'This record';
    this.setCaption();
    if (this.caption) {
      caption = this.caption;
    }
    this.genericdatasetService.setrestName(this.restName);
    this.genericdatasetService
      .deleteItem(this.item, this.id)
      .subscribe(
      (item) => {
        const id: number = this.id;
        this.id = 0;
        this.updateModal();
        const toast: any = toastr.success(caption + '<br><a data-toggle="tooltip" title="Cancel delete" class="btn-floating btn-small red" id="undoDeleteButton"><i class="fa fa-rotate-left"></i></a>', 'Delete', { enableHTML: true });
        toast.delegate('#undoDeleteButton', 'click', () => this.undoDelete(id));
      },
      (error) => {
        this.error = error;
        toastr.error(caption + ', ne peut pas être sauvegardé', 'Erreur');
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  onReset() {
    this.form.reset(this.item);
  }

  undoDelete(id: number): void {
    this.id = id;
    if (this.form.controls['active'] == null) {
      this.form.addControl('active', new FormControl(true));
    } else {
      this.form.controls['active'].setValue(true);
    }
    this.onSubmit(this.form);
  }

  onValidation() {
    this.checkControl(this.form.controls);
  }

  checkControl(controls: any) {
    for (const control in controls) {
      if (controls[control] instanceof FormArray) {
        for (let i = 0; i <= controls[control].controls.length - 1; i++) {
          this.checkControl(controls[control].controls[i].controls);
        }
      } else {
        controls[control].updateValueAndValidity();
      }
    }
  }

  checkValid(): boolean {
    this.onValidation();
    if (!this.form.valid) {
      if (this.caption) {
        toastr.error(this.caption + " ne peut pas être sauvegardé", 'Erreur');
      } else {
        toastr.error("Cet enregistrement ne peut pas être sauvegardé", 'Erreur');
      }
    }
    return this.form.valid;
  }

  public onSubmit(form: any): Promise<any> {
    const reactiveForm: any = this;
    return new Promise(
      function (resolve, reject) {
        if (!reactiveForm.checkValid()) {
          return;
        }
        reactiveForm.loading = true;
        reactiveForm.item = reactiveForm.form.value;
        reactiveForm.beforeSubmit(reactiveForm.item);
        reactiveForm.genericdatasetService.setrestName(reactiveForm.restName);
        reactiveForm.genericdatasetService
          .saveItem(reactiveForm.item, reactiveForm.id)
          .subscribe(
          (item: any) => {
            reactiveForm.afterSubmit(item);
            reactiveForm.validatorFromObject();
            reactiveForm.buildForm();
            if (reactiveForm.id == 0) {
              reactiveForm.reactiveformService.justCreated = true;
              reactiveForm.router.navigate([String(reactiveForm.router.url).replace('/0', '/' + item['id'])], { replaceUrl: true });
            }
            let caption = 'Sauvegarder';
            if (reactiveForm.caption != null) {
              caption = caption + ' ' + reactiveForm.caption;
            }
            toastr.success(caption);
            reactiveForm.updateModal();
            reactiveForm.created.emit(item);
            resolve();
          },
          (error: any) => {
            reactiveForm.error = error;
            toastr.error('Erreur');
            reactiveForm.loading = false;
            reject();
          },
          () => {
            reactiveForm.loading = false;
          });
      });
  }

  beforeCreate() {
  }

  onCreate() {
    this.beforeCreate();
    this.router.navigate(['/', this.backLink, 0]);
  }

  validatorFromObject(): void {
    const validatorObject: any = {};
    const validationMessages = {};
    const formErrors = {};
    const validatorForm = {};
    for (const field in this.item) {
      if (!(field in validatorObject)) {
        validatorObject[field] = [this.item[field]];
      }
    }
    this.formErrors = formErrors;
    this.validationMessages = validationMessages;
    this.validators = validatorObject;
  }

  beforeSubmit(item: any) {
    if (item.active == null) {
      item.active = true;
    }
    if (item.id > 111) {
      if (item.c_date == null) {
        item.c_date = new Date().toISOString();
      }
      item.m_date = new Date().toISOString();
    } else {
      if (this.id == 0) {
        item.active = true;
        delete item['id'];
      }
      item.c_date = new Date().toISOString();
    }
  }

  afterSubmit(item: any) {
  }

  buildForm(): void {
    if (this.form) {
      this.form.patchValue(this.item);
    } else {
      this.form = this.fb.group(this.validators);
      this.form.valueChanges.subscribe((value) => {
        this.updated.emit(value);
      });
      this.form.statusChanges.subscribe((value) => {
        this.statusChange(value);
      });
    }
    this.active = true;
  }

  statusChange(value: string) {
  }

  onValueChanged(data?: any) {
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid && control.errors) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          if (key in messages) {
            this.formErrors[field] += messages[key] + ' ';
          }
        }
      }
    }
  }

  goBack() {
    if (this.reactiveformService.justCreated) {
      this.router.navigate([this.reactiveformService.backLink]);
    } else {
      this.location.back();
    }
  }

  updateModal() {
    if (this.modal && this.closeModalAfterSave) {
      this.close(this.id);
    }
  }

  onClose() {
    if (this.modal) {
      this.close(this.id);
    }
  }
}
